import { useRef, useCallback } from 'react';

// Versão do spellchecker que funciona no browser (sem dependência de Node.js)

// Configuração de palavras em português brasileiro
const ptBRDictionary = new Set([
  // Palavras comuns em português
  'ola', 'bom', 'dia', 'tarde', 'noite', 'oi', 'tudo', 'bem',
  'obrigado', 'obrigada', 'por', 'favor', 'de', 'nada', 'agradeço',
  'cliente', 'atendimento', 'suporte', 'ajuda', 'problema', 'solução', 'resolvido',
  'mensagem', 'enviado', 'recebido', 'resposta', 'responder', 'aguardando',
  'sistema', 'funciona', 'funcionando', 'erro', 'corrigido', 'consertado',
  'pedido', 'encomenda', 'entrega', 'envio', 'chegada', 'prazo', 'status',
  'produto', 'serviço', 'qualidade', 'preço', 'valor', 'custo', 'pagamento',
  'contato', 'telefone', 'email', 'whatsapp', 'endereço', 'informação',
  'empresa', 'negócio', 'trabalho', 'funcionário', 'atendente', 'gerente',
  'agora', 'depois', 'antes', 'hoje', 'amanhã', 'ontem', 'semana', 'mês', 'ano',
  'sim', 'não', 'talvez', 'certeza', 'dúvida', 'concordo', 'discordo',
  'porque', 'motivo', 'razão', 'causa', 'explicação', 'entendido',
  'importante', 'urgente', 'prioridade', 'necessário', 'essencial',
  'aguardar', 'esperar', 'paciência', 'tempo', 'minuto', 'hora', 'dia',
  'verificar', 'confirmar', 'saber', 'informar', 'avisar', 'comunicar',
  'finalizado', 'concluído', 'pronto', 'ok', 'certo', 'correto',
  'desculpe', 'desculpa', 'erro', 'engano', 'equivocação', 'falha',
  'bem', 'vindo', 'seja', 'sejam', 'venha', 'venham', 'chegou', 'chegaram',
  'tchau', 'ate', 'logo', 'depois', 'breve', 'em', 'breve',
  // Palavras simples e muito comuns
  'teste', 'testar', 'testado', 'testando', 'prova', 'provar', 'experimento',
  'pode', 'podem', 'posso', 'podemos', 'podeis', 'podia', 'podiam',
  'quer', 'querem', 'quero', 'queremos', 'quereis', 'queria', 'queriam',
  'vai', 'vao', 'vou', 'vamos', 'vais', 'vai', 'iam', 'iamos',
  'tem', 'temos', 'tens', 'tendem', 'tinha', 'tinhamos', 'tinham',
  'estou', 'esta', 'estamos', 'estais', 'estao', 'estava', 'estavamos', 'estavam',
  'sou', 'somos', 'sois', 'sao', 'era', 'eramos', 'eram',
  'fui', 'foi', 'fomos', 'fostes', 'foram', 'fora', 'foras', 'fora',
  'darei', 'dara', 'daremos', 'dareis', 'darao', 'dei', 'deu', 'demos', 'destes', 'deram',
  'disse', 'dissemos', 'disseram', 'digo', 'dizemos', 'dizem', 'dizia', 'diziamos', 'diziam',
  'vi', 'viu', 'vimos', 'vistes', 'viram', 'vejo', 've', 'vemos', 'vedes', 'veem', 'via', 'viamos', 'viam',
  'faco', 'faz', 'fazemos', 'fazeis', 'fazem', 'fazia', 'faziamos', 'faziam',
  'mandei', 'mandou', 'mandamos', 'mandastes', 'mandaram', 'mando', 'mandamos', 'mandais', 'mandam',
  'enviei', 'enviou', 'enviamos', 'enviastes', 'enviaram', 'envio', 'enviamos', 'enviais', 'enviam',
  'recebi', 'recebeu', 'recebemos', 'recebestes', 'receberam', 'recebo', 'recebemos', 'recebeis', 'recebem',
  'peguei', 'pegou', 'pegamos', 'pegastes', 'pegaram', 'pego', 'pegamos', 'pegais', 'pegam',
  'levei', 'levou', 'levamos', 'levastes', 'levaram', 'levo', 'levamos', 'levais', 'levam',
  'trouxe', 'trouxemos', 'trouxeste', 'trouxeram', 'trago', 'trouxer', 'trouxermos', 'trouxerdes', 'trouxerem',
  'chamei', 'chamou', 'chamamos', 'chamastes', 'chamaram', 'chamo', 'chamamos', 'chamais', 'chamam',
  'falei', 'falou', 'falamos', 'falastes', 'falaram', 'falo', 'falamos', 'falais', 'falam',
  'contei', 'contou', 'contamos', 'contastes', 'contaram', 'conto', 'contamos', 'contais', 'contam',
  'entendi', 'entendeu', 'entendemos', 'entendestes', 'entenderam', 'entendo', 'entendemos', 'entendeis', 'entendem',
  'abri', 'abriu', 'abrimos', 'abristes', 'abriram', 'abro', 'abrimos', 'abris', 'abrem',
  'fechei', 'fechou', 'fechamos', 'fechastes', 'fecharam', 'fecho', 'fechamos', 'fechais', 'fecham',
  'entrei', 'entrou', 'entramos', 'entrastes', 'entraram', 'entro', 'entramos', 'entrais', 'entram',
  'sai', 'saiu', 'saimos', 'saiste', 'sairam', 'saio', 'saimos', 'sais', 'saem',
  'comecei', 'comecou', 'comecamos', 'comecastes', 'comecaram', 'comeco', 'comecamos', 'comecais', 'comecam',
  'terminei', 'terminou', 'terminamos', 'terminastes', 'terminaram', 'termino', 'terminamos', 'terminais', 'terminam',
  'acabei', 'acabou', 'acabamos', 'acabastes', 'acabaram', 'acabo', 'acabamos', 'acabais', 'acabam',
  'arrumei', 'arrumou', 'arrumamos', 'arrumastes', 'arrumaram', 'arrumo', 'arrumamos', 'arrumais', 'arrumam',
  'corrigi', 'corrigiu', 'corrigimos', 'corrigistes', 'corrigiram', 'corrijo', 'corrigimos', 'corrigeis', 'corrigem',
  'melhorei', 'melhorou', 'melhoramos', 'melhorastes', 'melhoraram', 'melhoro', 'melhoramos', 'melhorais', 'melhoram',
  'pior', 'piorou', 'pioramos', 'piorastes', 'pioraram', 'piora', 'pioramos', 'piorais', 'pioram',
  'agradeci', 'agradeceu', 'agradecemos', 'agradecesces', 'agradeceram', 'agradeco', 'agradecemos', 'agradecedeis', 'agradecem',
  // Palavras de uso diário
  'agua', 'cafe', 'comida', 'janta', 'almoco', 'cafe', 'lanche',
  'casa', 'apartamento', 'rua', 'avenida', 'bairro', 'cidade',
  'carro', 'moto', 'onibus', 'metro', 'taxi', 'uber',
  'escola', 'faculdade', 'universidade', 'aula', 'prova', 'nota',
  'hospital', 'medico', 'enfermeira', 'remedio', 'doenca', 'saude',
  'dinheiro', 'cartao', 'banco', 'caixa', 'troco', 'conta',
  'familia', 'pai', 'mae', 'filho', 'filha', 'irmao', 'irma',
  'amigo', 'amiga', 'amigos', 'amigas', 'conhecido', 'conhecida',
  'tempo', 'clima', 'sol', 'chuva', 'frio', 'calor', 'vento',
  'comprar', 'vender', 'trocar', 'devolver', 'trocar', 'emprestar',
  'feliz', 'triste', 'alegre', 'chateado', 'bravo', 'calmo', 'nervoso',
  'bonito', 'feio', 'grande', 'pequeno', 'alto', 'baixo', 'gordo', 'magro',
  'bom', 'ruim', 'otimo', 'pessimo', 'excelente', 'regular', 'medio',
  'facil', 'dificil', 'simples', 'complexo', 'complicado', 'direto',
  'rapido', 'lento', 'depressa', 'devagar', 'cedo', 'tarde', 'noite',
  'sempre', 'nunca', 'as vezes', 'raramente', 'frequentemente',
  'aqui', 'ali', 'la', 'perto', 'longe', 'dentro', 'fora', 'acima', 'abaixo',
  // Mais palavras comuns do dia a dia
  'pessoas', 'pessoa', 'gente', 'todos', 'todas', 'ninguem', 'alguem',
  'coisas', 'coisa', 'tudo', 'nada', 'algo', 'muito', 'pouco', 'bastante',
  'mesmo', 'mesma', 'mesmos', 'mesmas', 'outro', 'outra', 'outros', 'outras',
  'qualquer', 'quaisquer', 'certo', 'certa', 'certos', 'certas', 'algum',
  'alguma', 'alguns', 'algumas', 'nenhum', 'nenhuma', 'nenhuns', 'nenhumas',
  'todo', 'toda', 'todos', 'todas', 'varios', 'varias', 'diversos', 'diversas',
  'muitos', 'muitas', 'poucos', 'poucas', 'tanto', 'tanta', 'tantos', 'tantas',
  // Palavras de negócio e trabalho
  'reuniao', 'reunir', 'reunido', 'reunidos', 'equipe', 'grupo', 'time',
  'projeto', 'projetos', 'tarefa', 'tarefas', 'atividade', 'atividades',
  'meta', 'metas', 'objetivo', 'objetivos', 'plano', 'planos', 'estrategia',
  'resultado', 'resultados', 'desempenho', 'produtividade', 'eficiencia',
  'relatorio', 'relatorios', 'documento', 'documentos', 'arquivo', 'arquivos',
  'apresentacao', 'apresentacoes', 'palestra', 'palestras', 'treinamento',
  'curso', 'cursos', 'workshop', 'workshops', 'seminario', 'seminarios',
  'cliente', 'clientes', 'fornecedor', 'fornecedores', 'parceiro', 'parceiros',
  'contrato', 'contratos', 'acordo', 'acordos', 'negocio', 'negocios',
  'venda', 'vendas', 'compra', 'compras', 'pedido', 'pedidos', 'encomenda',
  'orcamento', 'orcamentos', 'proposta', 'propostas', 'oferta', 'ofertas',
  'desconto', 'descontos', 'promocao', 'promocoes', 'campanha', 'campanhas',
  // Palavras de tecnologia
  'computador', 'computadores', 'notebook', 'notebooks', 'celular', 'celulares',
  'smartphone', 'smartphones', 'tablet', 'tablets', 'internet', 'rede',
  'wifi', 'wireless', 'bluetooth', 'usb', 'hdmi', 'software', 'programa',
  'aplicativo', 'aplicativos', 'app', 'apps', 'site', 'sites', 'website',
  'pagina', 'paginas', 'link', 'links', 'url', 'urls', 'email', 'emails',
  'senha', 'senhas', 'login', 'logout', 'acesso', 'acessar', 'conectar',
  'desconectar', 'online', 'offline', 'digital', 'eletronico', 'virtual',
  'sistema', 'sistemas', 'plataforma', 'plataformas', 'ferramenta', 'ferramentas',
  'tecnologia', 'tecnologias', 'inovacao', 'inovacoes', 'atualizacao',
  'download', 'uploads', 'anexo', 'anexos', 'arquivo', 'arquivos',
  // Palavras de comunicação
  'conversar', 'conversa', 'dialogar', 'dialogo', 'conversacao', 'conversacoes',
  'discutir', 'discussao', 'debater', 'debate', 'opinar', 'opiniao', 'opinioes',
  'comentar', 'comentario', 'comentarios', 'responder', 'resposta', 'respostas',
  'perguntar', 'pergunta', 'perguntas', 'questionar', 'questao', 'questoes',
  'informar', 'informacao', 'informacoes', 'avisar', 'aviso', 'avisos',
  'notificar', 'notificacao', 'notificacoes', 'comunicar', 'comunicacao',
  'mensagem', 'mensagens', 'recado', 'recados', 'bilhete', 'bilhetes',
  'carta', 'cartas', 'telefone', 'telefonar', 'ligacao', 'ligacoes',
  // Palavras de sentimentos e emoções
  'feliz', 'alegre', 'contente', 'satisfeito', 'satisfeita', 'satisfeitos',
  'triste', 'chateado', 'frustrado', 'decepcionado', 'preocupado', 'nervoso',
  'calmo', 'tranquilo', 'relaxado', 'pacifico', 'sereno', 'pacato',
  'bravo', 'raivoso', 'irritado', 'zangado', 'furioso', 'indignado',
  'medo', 'medo', 'medo', 'com medo', 'assustado', 'apavorado', 'terrorizado',
  'corajoso', 'valente', 'destemido', 'corajosa', 'valente', 'destemida',
  'amor', 'amar', 'amado', 'amada', 'amados', 'amadas', 'apaixonado',
  'odio', 'odiar', 'odiado', 'odiada', 'odiados', 'odiadas', 'detestado',
  'gostar', 'gosto', 'gostei', 'gostou', 'gostamos', 'gostaram', 'gostar',
  // Palavras de descrição
  'bonito', 'bonita', 'lindo', 'linda', 'belo', 'bela', 'formoso', 'formosa',
  'feio', 'feia', 'horroroso', 'horrorosa', 'terrivel', 'pessimo', 'pessima',
  'grande', 'enorme', 'gigante', 'imenso', 'pequeno', 'minúsculo', 'tiny',
  'alto', 'altissimo', 'baixo', 'baixissimo', 'gordo', 'gordao', 'magro',
  'magro', 'magricela', 'delgado', 'delgada', 'forte', 'fortissimo', 'fraco',
  'novo', 'novinho', 'velho', 'velhinho', 'antigo', 'moderno', 'atualizado',
  'limpo', 'limpinho', 'sujo', 'sujo', 'sujinho', 'organizado', 'baguncado',
  'claro', 'clarissimo', 'escuro', 'escurissimo', 'brilhante', 'opaco',
  'quente', 'quentissimo', 'frio', 'frio', 'gelado', 'morno', 'fresco',
  'molhado', 'molhado', 'enxuto', 'seco', 'secarrão', 'umido', 'molhado',
  // Palavras de movimento e ação
  'andar', 'caminhar', 'correr', 'corrida', 'pular', 'pulo', 'saltar',
  'nadar', 'nado', 'voar', 'voo', 'subir', 'descer', 'entrar', 'sair',
  'chegar', 'partir', 'ir', 'vir', 'voltar', 'retornar', 'sair', 'embora',
  'mover', 'movimento', 'mexer', 'deslocar', 'transportar', 'carregar',
  'empurrar', 'puxar', 'levantar', 'abaixar', 'sentar', 'levantar',
  'deitar', 'deitado', 'sentado', 'em pe', 'ajoelhado', 'agachado',
  // Palavras de comida e bebida
  'comida', 'comer', 'alimentacao', 'nutricao', 'dieta', 'regime',
  'cafe', 'cafezinho', 'agua', 'aguinha', 'refrigerante', 'suco',
  'leite', 'leite', 'vinho', 'cerveja', 'bebida', 'bebidas', 'copo',
  'prato', 'pratos', 'garfo', 'faca', 'colher', 'talher', 'talheres',
  'mesa', 'mesas', 'cadeira', 'cadeiras', 'copo', 'copos', 'xícara',
  'pao', 'pães', 'bolo', 'bolos', 'torta', 'tortas', 'doce', 'doces',
  'salgado', 'salgados', 'fruta', 'frutas', 'legume', 'legumes', 'verdura',
  // Palavras de tempo e clima
  'tempo', 'clima', 'tempo', 'meteorologia', 'previsao', 'previsao',
  'sol', 'sol', 'ensolarado', 'lua', 'luar', 'estrela', 'estrelas',
  'chuva', 'chuvoso', 'chuvoso', 'garoa', 'trovao', 'relampago', 'tempestade',
  'nuvem', 'nuvens', 'ceu', 'ceus', 'ar', 'vento', 'ventania', 'brisa',
  'frio', 'frio', 'gelado', 'calor', 'calor', 'quente', 'abafado',
  'seco', 'seco', 'umido', 'mido', 'molhado', 'encharcado',
  'manha', 'manha', 'tarde', 'noite', 'madrugada', 'dia', 'dias',
  'semana', 'semanas', 'mes', 'meses', 'ano', 'anos', 'decada', 'seculo',
  'primavera', 'verao', 'outono', 'inverno', 'estacao', 'estacoes',
  // Verbos comuns
  'ser', 'estar', 'ter', 'haver', 'fazer', 'poder', 'dever', 'querer',
  'saber', 'dar', 'dizer', 'ver', 'vir', 'ir', 'ficar', 'passar',
  'mandar', 'enviar', 'receber', 'pegar', 'levar', 'trazer', 'chamar',
  'falar', 'contar', 'explicar', 'entender', 'compreender', 'saber',
  'ajudar', 'atender', 'servir', 'trabalhar', 'funcionar', 'operar',
  'comprar', 'vender', 'pagar', 'cobrar', 'custar', 'valer',
  'abrir', 'fechar', 'entrar', 'sair', 'começar', 'terminar', 'acabar',
  'arrumar', 'consertar', 'corrigir', 'melhorar', 'piorar',
  'agradecer', 'agradecido', 'agradecida', 'agradecemos', 'agradecem',
  // Conectivos e preposições
  'e', 'ou', 'mas', 'porem', 'contudo', 'entretanto', 'todavia',
  'que', 'quem', 'qual', 'quais', 'quando', 'onde', 'como', 'porque',
  'para', 'por', 'com', 'sem', 'em', 'de', 'da', 'do', 'no', 'na',
  'ate', 'sobre', 'sob', 'entre', 'desde', 'durante', 'mediante',
  'segundo', 'conforme', 'salvo', 'exceto',
  // Pronomes
  'eu', 'tu', 'voce', 'ele', 'ela', 'nos', 'vos', 'eles', 'elas',
  'me', 'te', 'se', 'lhe', 'o', 'a', 'lo', 'la', 'nos', 'vos', 'lhes',
  'meu', 'minha', 'teu', 'tua', 'seu', 'sua', 'nosso', 'nossa',
  'este', 'esta', 'esse', 'essa', 'isto', 'isso', 'aquilo',
  'aquele', 'aquela', 'aqueles', 'aquelas',
  // Números e quantidades
  'zero', 'um', 'dois', 'tres', 'quatro', 'cinco', 'seis', 'sete',
  'oito', 'nove', 'dez', 'onze', 'doze', 'treze', 'quatorze', 'quinze',
  'dezesseis', 'dezessete', 'dezoito', 'dezenove', 'vinte', 'trinta',
  'quarenta', 'cinquenta', 'sessenta', 'setenta', 'oitenta', 'noventa',
  'cem', 'duzentos', 'trezentos', 'quatrocentos', 'quinhentos', 'seiscentos',
  'setecentos', 'oitocentos', 'novecentos', 'mil', 'milhao', 'bilhao',
  'primeiro', 'segundo', 'terceiro', 'quarto', 'quinto', 'sexto',
  'setimo', 'oitavo', 'nono', 'decimo', 'ultimo', 'proximo',
  // Termos de negócio
  'orcamento', 'proposta', 'contrato', 'acordo', 'negociacao', 'negocio',
  'venda', 'compra', 'troca', 'devolucao', 'reembolso', 'estorno',
  'nota', 'fiscal', 'cupom', 'recibo', 'comprovante', 'documento',
  'estoque', 'disponivel', 'indisponivel', 'esgotado', 'acabou',
  'promocao', 'desconto', 'oferta', 'preco', 'valor', 'custo',
  'frete', 'entrega', 'transporte', 'correios', 'motoboy',
  'garantia', 'defeito', 'problema', 'solucao', 'reparo', 'manutencao',
  // Saudações e despedidas
  'bom', 'dia', 'boa', 'tarde', 'boa', 'noite', 'ola', 'oi',
  'tudo', 'bem', 'como', 'vai', 'tudo', 'bem',
  'tchau', 'ate', 'logo', 'ate', 'mais', 'ate', 'breve',
  'bom', 'apetite', 'boa', 'sorte', 'bom', 'ferias',
  // Expressões comuns
  'com', 'certeza', 'sem', 'duvida', 'com', 'prazer', 'por', 'gentileza',
  'se', 'possivel', 'se', 'necessario', 'por', 'favor', 'por', 'obséquio',
  'nao', 'se', 'preocupe', 'fique', 'tranquilo', 'sem', 'problemas',
  'sem', 'dificuldade', 'com', 'certeza', 'claro', 'sim',
  'desculpe', 'incomodar', 'desculpe', 'perturbar',
  // Termos técnicos
  'aplicativo', 'aplicacao', 'software', 'programa', 'sistema',
  'computador', 'celular', 'telefone', 'tablet', 'dispositivo',
  'internet', 'wifi', 'rede', 'conexao', 'online', 'offline',
  'site', 'pagina', 'link', 'endereco', 'url', 'dominio',
  'senha', 'codigo', 'acesso', 'login', 'logout',
  'arquivo', 'documento', 'foto', 'imagem', 'video', 'audio',
  'download', 'upload', 'anexo', 'enviar', 'receber',
  // Adicionais para contexto de atendimento
  'protocolo', 'numero', 'rastreamento', 'localizacao',
  'agendamento', 'horario', 'data', 'periodo', 'intervalo',
  'politica', 'regra', 'norma', 'procedimento', 'processo',
  'setor', 'departamento', 'equipe', 'grupo', 'time',
  'supervisor', 'coordenador', 'gerente', 'diretor', 'presidente',
  'cliente', 'consumidor', 'usuario', 'visitante', 'parceiro',
  'fornecedor', 'distribuidor', 'revendedor', 'representante',
  'item', 'artigo', 'mercadoria', 'bem', 'servico',
  'qualidade', 'quantidade', 'especificacao', 'caracteristica',
  'modelo', 'versao', 'tipo', 'categoria', 'linha', 'colecao',
  'cor', 'tamanho', 'medida', 'peso', 'dimensao', 'formato',
  'material', 'fabricacao', 'origem', 'marca', 'fabricante',
  'garantia', 'validade', 'vencimento', 'prazo', 'periodo',
  'reclamacao', 'sugestao', 'elogio', 'critica', 'comentario',
  'opiniao', 'avaliacao', 'nota', 'conceito', 'classificacao',
  'recomendacao', 'indicacao', 'referencia', 'experiencia',
  'satisfacao', 'insatisfacao', 'contentamento', 'frustracao',
  'expectativa', 'realidade', 'promessa', 'cumprimento',
  'atraso', 'adiantamento', 'cancelamento', 'suspensao',
  'confirmacao', 'verificacao', 'validacao', 'autenticacao',
  'autorizacao', 'permissao', 'liberacao', 'aprovacao',
  'negacao', 'recusa', 'rejeicao', 'impossibilidade',
  'alternativa', 'opcao', 'escolha', 'decisao', 'definicao',
  'duvida', 'questionamento', 'esclarecimento', 'orientacao',
  'instrucao', 'manual', 'guia', 'tutorial', 'ajuda',
  'suporte', 'assistencia', 'auxilio', 'colaboracao',
  'parceria', 'cooperacao', 'integracao', 'conexao',
  'comunicacao', 'informacao', 'notificacao', 'aviso',
  'alerta', 'mensagem', 'recado', 'bilhete',
  'carta', 'email', 'telefone', 'ligacao', 'chamada',
  'conversa', 'dialogo', 'entrevista', 'reuniao',
  'pauta', 'assunto', 'tema', 'topico', 'materia',
  'conteudo', 'texto', 'descricao', 'explicacao',
  'resumo', 'sintese', 'conclusao', 'resultado',
  'efeito', 'consequencia', 'impacto', 'influencia',
  'causa', 'motivo', 'razao', 'justificativa',
  'fundamento', 'base', 'estrutura', 'organizacao',
  'planejamento', 'estrategia', 'tatica', 'tecnica',
  'metodo', 'sistema', 'processo', 'procedimento',
  'regra', 'norma', 'padrao', 'criterio', 'parametro',
  'limite', 'fronteira', 'barreira', 'obstaculo',
  'desafio', 'dificuldade', 'problema', 'situacao',
  'contexto', 'cenario', 'ambiente', 'espaco',
  'local', 'lugar', 'posicao', 'localizacao',
  'endereco', 'rota', 'caminho', 'direcao',
  'distancia', 'proximidade', 'vizinhanca',
  'relacao', 'conexao', 'vinculo', 'ligacao',
  'contato', 'interface', 'interacao', 'integracao',
  'funcionalidade', 'recurso', 'ferramenta', 'utilitario',
  'aplicativo', 'programa', 'software', 'hardware',
  'tecnologia', 'inovacao', 'modernizacao', 'atualizacao',
  'versao', 'release', 'update', 'upgrade',
  'instalacao', 'configuracao', 'ajuste', 'personalizacao',
  'adaptacao', 'compatibilidade', 'integracao',
  'seguranca', 'protecao', 'bloqueio', 'desbloqueio',
  'acesso', 'entrada', 'saida', 'permissao',
  'autenticacao', 'verificacao', 'validacao',
  'backup', 'copia', 'restauracao', 'recuperacao',
  'erro', 'falha', 'defeito', 'bug', 'glitch',
  'correcao', 'conserto', 'reparo', 'manutencao',
  'otimizacao', 'melhoria', 'aperfeicoamento',
  'desempenho', 'velocidade', 'rapidez', 'eficiencia',
  'qualidade', 'padrao', 'nivel', 'grau',
  'escala', 'tamanho', 'dimensao', 'proporcao',
  'quantidade', 'volume', 'numero', 'valor',
  'preco', 'custo', 'investimento', 'gasto',
  'economia', 'poupanca', 'desconto', 'promocao',
  'oferta', 'proposta', 'negocio', 'transacao',
  'venda', 'compra', 'troca', 'permuta',
  'entrega', 'distribuicao', 'transporte',
  'logistica', 'armazenamento', 'estoque',
  'disponibilidade', 'acesso', 'reserva',
  'agendamento', 'marcacao', 'compromisso',
  'horario', 'periodo', 'turno', 'expediente',
  'funcionamento', 'operacao', 'atividade',
  'producao', 'criacao', 'desenvolvimento',
  'projeto', 'plano', 'estrategia', 'meta',
  'objetivo', 'finalidade', 'proposito',
  'missao', 'visao', 'valor', 'principio',
  'filosofia', 'cultura', 'ambiente',
  'clima', 'atmosfera', 'energia', 'vibracao'
]);

// Remove acentos/diacríticos (ex: "olá" -> "ola") sem depender de escapes de
// regex para os pontos de código dos caracteres combinantes (U+0300-U+036F)
function stripDiacritics(str: string): string {
  return str
    .normalize('NFD')
    .split('')
    .filter((ch) => {
      const code = ch.charCodeAt(0);
      return code < 0x0300 || code > 0x036f;
    })
    .join('');
}

// Dicionário normalizado (sem acentos) para permitir que palavras corretas
// acentuadas (ex: "olá") sejam reconhecidas mesmo com entradas sem acento no dicionário
const ptBRDictionaryNormalized = new Set(
  Array.from(ptBRDictionary, (w) => stripDiacritics(w))
);

export interface SpellCheckResult {
  word: string;
  isCorrect: boolean;
  suggestions?: string[];
}

export interface SpellCheckOptions {
  language?: string;
  ignoreNumbers?: boolean;
  ignoreEmails?: boolean;
  ignoreUrls?: boolean;
  ignoreCase?: boolean;
  minWordLength?: number;
}

class SpellChecker {
  private options: SpellCheckOptions;

  constructor(options: SpellCheckOptions = {}) {
    this.options = {
      language: 'pt-BR',
      ignoreNumbers: true,
      ignoreEmails: true,
      ignoreUrls: true,
      ignoreCase: true,
      minWordLength: 2,
      ...options
    };
  }

  // Verifica se uma palavra deve ser ignorada
  private shouldIgnore(word: string): boolean {
    if (word.length < this.options.minWordLength!) {
      return true;
    }

    if (this.options.ignoreNumbers && /^\d+$/.test(word)) {
      return true;
    }

    if (this.options.ignoreEmails && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(word)) {
      return true;
    }

    if (this.options.ignoreUrls && /^https?:\/\/.+/i.test(word)) {
      return true;
    }

    return false;
  }

  // Limpa uma palavra para verificação
  private cleanWord(word: string): string {
    // Remove pontuação no final e início
    word = word.replace(/^["'(){}\[\]<>]+|["'(){}\[\]<>]+$/g, '');

    // Remove caracteres especiais mas mantém acentos
    word = word.replace(/[^\w\sáàâãéèêíïóôõöúüñçÁÀÂÃÉÈÊÍÏÓÔÕÖÚÜÑÇ]/g, '');

    if (this.options.ignoreCase) {
      word = word.toLowerCase();
    }

    return word;
  }

  // Calcula distância de Damerau-Levenshtein entre duas palavras (inclui
  // transposição de letras adjacentes com custo 1, ex: "oal" -> "ola")
  private editDistance(str1: string, str2: string): number {
    const len1 = str1.length;
    const len2 = str2.length;
    const matrix: number[][] = [];

    for (let i = 0; i <= len1; i++) {
      matrix[i] = [i];
    }

    for (let j = 0; j <= len2; j++) {
      matrix[0][j] = j;
    }

    for (let i = 1; i <= len1; i++) {
      for (let j = 1; j <= len2; j++) {
        const cost = str1.charAt(i - 1) === str2.charAt(j - 1) ? 0 : 1;

        matrix[i][j] = Math.min(
          matrix[i - 1][j] + 1,      // remoção
          matrix[i][j - 1] + 1,      // inserção
          matrix[i - 1][j - 1] + cost // substituição
        );

        // Transposição de duas letras adjacentes (ex: "oal" <-> "ola")
        if (
          i > 1 && j > 1 &&
          str1.charAt(i - 1) === str2.charAt(j - 2) &&
          str1.charAt(i - 2) === str2.charAt(j - 1)
        ) {
          matrix[i][j] = Math.min(matrix[i][j], matrix[i - 2][j - 2] + 1);
        }
      }
    }

    return matrix[len1][len2];
  }

  // Obtém sugestões para uma palavra
  private getSuggestions(word: string): string[] {
    const normalizedWord = stripDiacritics(word);
    // Limite mais tolerante para palavras curtas, onde um único erro de
    // digitação (troca/transposição de letra) já representa boa parte da palavra
    const maxDistance = Math.max(2, Math.ceil(word.length * 0.4));

    const candidates: { word: string; distance: number }[] = [];

    // Busca palavras similares no dicionário (ignorando acentos na comparação)
    for (const dictWord of ptBRDictionary) {
      const distance = this.editDistance(normalizedWord, stripDiacritics(dictWord));

      if (distance > 0 && distance <= maxDistance) {
        candidates.push({ word: dictWord, distance });
      }
    }

    // Ordena por distância (mais similares primeiro) e limita a 5 sugestões
    return candidates
      .sort((a, b) => a.distance - b.distance)
      .slice(0, 5)
      .map((c) => c.word);
  }

  // Verifica uma única palavra
  checkWord(word: string): SpellCheckResult {
    const cleanWord = this.cleanWord(word);

    if (this.shouldIgnore(cleanWord) || cleanWord.length === 0) {
      return { word, isCorrect: true };
    }

    const isCorrect = ptBRDictionary.has(cleanWord) || ptBRDictionaryNormalized.has(stripDiacritics(cleanWord));

    return {
      word,
      isCorrect,
      suggestions: isCorrect ? undefined : this.getSuggestions(cleanWord)
    };
  }

  // Verifica um texto completo
  checkText(text: string): SpellCheckResult[] {
    if (!text || text.trim().length === 0) {
      return [];
    }

    // Divide em palavras mantendo a pontuação
    const words = text.match(/[\wáàâãéèêíïóôõöúüñçÁÀÂÃÉÈÊÍÏÓÔÕÖÚÜÑÇ]+|[^\s\w]/g) || [];

    return words
      .map(word => this.checkWord(word))
      .filter(result => !result.isCorrect);
  }

  // Corrige automaticamente um texto
  autoCorrect(text: string): string {
    const results = this.checkText(text);
    let correctedText = text;

    results.forEach(result => {
      if (result.suggestions && result.suggestions.length > 0) {
        // Usa a primeira sugestão
        const suggestion = result.suggestions[0];
        correctedText = correctedText.replace(result.word, suggestion);
      }
    });

    return correctedText;
  }

  // Adiciona palavras personalizadas ao dicionário
  addCustomWords(words: string[]): void {
    words.forEach(word => {
      const cleanWord = this.cleanWord(word);
      if (cleanWord.length > 0) {
        ptBRDictionary.add(cleanWord);
        ptBRDictionaryNormalized.add(stripDiacritics(cleanWord));
      }
    });
  }

  // Verifica se uma palavra existe no dicionário
  isWordInDictionary(word: string): boolean {
    const cleanWord = this.cleanWord(word);
    return ptBRDictionary.has(cleanWord) || ptBRDictionaryNormalized.has(stripDiacritics(cleanWord));
  }
}

// Instância global
const spellChecker = new SpellChecker();

// Hook para React
export const useSpellCheck = (options?: SpellCheckOptions) => {
  const checkerRef = useRef<SpellChecker | null>(null);
  if (!checkerRef.current) {
    checkerRef.current = new SpellChecker(options);
  }

  const checkWord = useCallback((word: string) => checkerRef.current!.checkWord(word), []);
  const checkText = useCallback((text: string) => checkerRef.current!.checkText(text), []);
  const autoCorrect = useCallback((text: string) => checkerRef.current!.autoCorrect(text), []);
  const addCustomWords = useCallback((words: string[]) => checkerRef.current!.addCustomWords(words), []);
  const isWordInDictionary = useCallback((word: string) => checkerRef.current!.isWordInDictionary(word), []);

  return { checkWord, checkText, autoCorrect, addCustomWords, isWordInDictionary };
};

export default spellChecker;
